module.exports = __webpack_public_path__ + "img/NFLX.b89bb6ed.png";